enum BannerSlideEnum {
  // Sore realna len' to translate
  Pokrivlia = 'Експлуатовані покрівлі',
  Fundament = 'Фундаменти',
  Fasad = 'Фасад з оздобленням індустріальними елементами',
  Stiny = 'Стіни та перегородки',
}

export default BannerSlideEnum;
